module.exports = __webpack_public_path__ + "static/media/plate-number.a0d84385.svg";